export default __webpack_public_path__ + "static/media/CapaCADViewer.3ae7739c.png";